import { render, staticRenderFns } from "./CbsDataReportConfig.vue?vue&type=template&id=44f4a5e2&scoped=true"
import script from "./CbsDataReportConfig.vue?vue&type=script&lang=js"
export * from "./CbsDataReportConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4a5e2",
  null
  
)

export default component.exports